export function propsToLink({ url, ...others }) {
  return { to: url, ...others };
}
